// SegmentPopup.jsx
import { useEffect, useState } from "react";
import { doc, getDoc } from "firebase/firestore";
import { db } from "../firebase";

const SegmentPopup = ({ visible, recordId, userId, onClose, formatTimestamp }) => {
  const [survey, setSurvey] = useState(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!visible || !recordId || !userId) {
      console.log("SegmentPopup: Not fetching, missing visible/recordId/userId", { visible, recordId, userId });
      return;
    }
    setLoading(true);
    const fetchSurvey = async () => {
      try {
        console.log("SegmentPopup: Fetching survey", { userId, recordId });
        const surveyRef = doc(db, "EMA", userId, "surveys", recordId);
        console.log("SegmentPopup: Firestore doc ref", surveyRef.path);
        const surveySnap = await getDoc(surveyRef);
        if (surveySnap.exists()) {
          console.log("SegmentPopup: Survey found", surveySnap.data());
          setSurvey(surveySnap.data());
        } else {
          console.warn("SegmentPopup: Survey not found for recordId", recordId);
          setSurvey(null);
        }
      } catch (err) {
        console.error("SegmentPopup: Error fetching survey", err);
        setSurvey(null);
      } finally {
        setLoading(false);
      }
    };
    fetchSurvey();
  }, [visible, recordId, userId]);

  if (!visible) return null;

  return (
    <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
      <div className="bg-white p-6 rounded shadow-xl max-w-md w-full">
        <h2 className="text-xl font-bold mb-4">Survey</h2>
        {loading && <p>Loading...</p>}
        {!loading && survey && (
          <>
            <p className="mb-1">
              <strong>Time:</strong> {formatTimestamp(survey.timestamp)}
            </p>
            <p className="mb-4">
              <strong>Survey Id:</strong> {survey.surveyId}
            </p>
            <p className="mb-4">
              <strong>Title</strong> {survey.title}
            </p>
            {survey.answers?.length > 0 && (
              <div className="mb-4">
                <h3 className="font-semibold mb-2">Answers:</h3>
                <ul className="space-y-2">
                  {survey.answers.map((a, idx) => (
                    <li key={idx} className="border p-2 rounded bg-gray-50">
                      <p className="text-sm text-gray-600"><strong>Q:</strong> {a.question}</p>
                      <p className="text-sm"><strong>A:</strong> {a.answer}</p>
                    </li>
                  ))}
                </ul>
              </div>
            )}
          </>
        )}
        {!loading && !survey && (
          <p className="text-red-500">Survey not found.</p>
        )}
        <button
          onClick={onClose}
          className="px-4 py-2 bg-blue-500 text-white rounded hover:bg-blue-600 transition"
        >
          Close
        </button>
      </div>
    </div>
  );
};

export default SegmentPopup;
